import React, { Component } from 'react';
import lodashFilter from 'lodash/filter';
import lodashForEach from 'lodash/forEach';
import lodashMap from 'lodash/map';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Button, ButtonToolbar, Row, Col } from 'react-bootstrap';
import { RowRenderer } from '../../Common/rowRenderer';
import { isVAK, ROOT_URL } from '../../../actions/root_url';
import axios from 'axios';

const propTypes = {
};

const defaultProps = {
};

class SkusTableModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      filters: null,
      sortColumn: null,
      sortDirection: null,
    };
  }

  componentDidMount() {
    this.setState({
      rows: JSON.parse(this.props.skus)
    })
    if (isVAK) {
      this.refreshTable();
    }

  }

  refreshTable = () => {
    let { Product_id } = this.props;
    let usTemp = [];
    axios
      .get(
        `${ROOT_URL}v2/product/sku/?product_id=` + Product_id,
        {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`,},},
      )
      .then(
        (res) => {
          res.data.map((r, idx)=>{
            usTemp.push({...r, product: Product_id, idx: idx + 1});
          });
          this.setState({rows: usTemp});
        },
        (err) => {
          if (err.data) {
            alert(err.data);
          } else {
            alert("Server issue detected, please contact admin.");
          }
        }
      );
  }

  uspDel = (data) => {
    axios.delete(
      `${ROOT_URL}v2/product/sku/` + data.id,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(
        (res) => {
          // alert("SKU Deleted");
          this.refreshTable();
        },
        (err) => {
          if (err.data) {
            alert(err.data);
          } else {
            alert("Server issue detected, please contact admin.");
          }
        }
      );
  }


  addSKU = () => {
    let { Product_id } = this.props;
    let {rows} = this.state;
    const newRow = {
      name: '',
      sku: '',
      product: Product_id,
      idx: Number(rows.length) + 1,
    }
    this.setState({
      rows: [...this.state.rows, newRow]
    })
  }

  delSKU = (idx) => {
    let {rows} = this.state;
    rows = rows.filter((obj) => {
      const match = obj.idx !== idx;
      return match;
    });
    rows.map((r,i) => {
      rows[i].idx = i+1;
    });
    this.setState({
      rows
    });
  }


  saveSKU = () => {
    let str = JSON.stringify(this.state.rows);
    this.props.updateSKU(str);
  };

  render() {
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const onClearFilters = () => {
      this.setState({ filters: {} });
    };

    const handleRowUpdated = (row) => {
      let newRow = this.state.rows;
      newRow[row.rowIdx] = {
        ...newRow[row.rowIdx],
        ...row.updated,
      }
      this.setState({
        rows: newRow,
      })
    };

    const handleSaveClick = row => {
      let {rows} = this.state;
      let uspTemp = null;
      if (isVAK) {
        const idx = row.idx - 1
        if (rows && rows[idx] && rows[idx].id && rows[idx].sku && rows[idx].name) {
          uspTemp = {name: rows[idx].name, sku: rows[idx].sku, product: rows[idx].product}
          setTimeout(() => {
            axios.put(
              `${ROOT_URL}v2/product/sku/` + rows[idx].id,
              uspTemp,
              {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
              },
            )
              .then((response) => {
                setTimeout(() => {
                  this.refreshTable();
                }, 300);
                // alert("SKU Saved");
              }, (err) => {
                if (err.status === 500 || err.status === 404) {
                  err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
                }
                alert(JSON.stringify(err.data));
                this.refreshTable();
              });
          }, 200);
        } else if (rows && rows[idx] && !rows[idx].id && rows[idx].sku && rows[idx].product) {
          uspTemp = {name: rows[idx].name, sku: rows[idx].sku, product: rows[idx].product}
          setTimeout(() => {
            axios.post(
              `${ROOT_URL}v2/product/sku/`,
              uspTemp,
              {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
              },
            )
              .then((response) => {
                setTimeout(() => {
                  this.refreshTable();
                }, 300);
                // alert("SKU Saved");
              }, (err) => {
                if (err.status === 500 || err.status === 404) {
                  err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
                }
                alert(JSON.stringify(err.data));
                this.refreshTable();
              });
          }, 200);
        }
      }
    }

    const columns = [
      {
        key: 'name',
        name: <Translate value="name" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: 'sku',
        name: <Translate value="sku" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      ...isVAK ? [{
        key: 'idx',
        name: <Translate value="operation" />,
        resizable: true,
        width: 90,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: '100%', height: '100%' }}
          >
            {
              dependentValues.id 
                ? <Button
                    bsStyle="danger"
                    className="textAlignStyle"
                    style={{ height: '23px', width: '39px', padding: '0px' }}
                    onClick={() => {
                      if(isVAK) {
                        this.uspDel(dependentValues);
                      } else {
                        this.delSKU(value);
                      }
                    }}
                  >X
                  </Button>
                : <Button 
                    bsStyle="success" 
                    className="textAlignStyle" 
                    style={{ height: '23px', width: '39px', padding: '0px' }}
                    onClick={() => {
                      handleSaveClick(dependentValues)
                    }}
                  >
                    <Translate value={'save'}/>
                  </Button>
            }
          </div>
        ),
        getRowMetaData: row => row,
      },
      ] : []
    ];

    return (
      <Row>
        <Col sm={12}>
          <ButtonToolbar>
            <Button
              type="button"
              bsStyle="primary"
              onClick={this.addSKU}
            >
              <em className="fa fa-plus" /><Translate value="add" />
            </Button>
            {!isVAK && <Button
              type="button"
              bsStyle="primary"
              onClick={this.saveSKU}
            >
              <em className="fa fa-save" /><Translate value="save" />
            </Button>}
          </ButtonToolbar>
          <div style={{ maxWidth: '100%', marginTop: '5px' }} id="linkProductsModal-dataGrid1">
            <ReactDataGrid
              rowKey="skus_table"
              enableCellSelect
              onRowUpdated={handleRowUpdated}
              rowHeight={25}
              minHeight={250}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

SkusTableModal.propTypes = propTypes;
SkusTableModal.defaultProps = defaultProps;

export default SkusTableModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/SkusModal.jsx